import React from 'react';
import {
  string, bool, number, func, shape
} from 'prop-types';
import classNames from 'classnames';

import { Image } from '@thd-olt-component-react/image';
import { LoadingPlaceholder } from '@thd-olt-component-react/loading-placeholder';

import { noop, sanitizeImageUrl } from '../../../../utils/promo-utils';
import { usePromoModel } from '../../../../contexts/PromoModelProvider';
import { usePromoCart } from '../../../../contexts/PromoCartProvider';
import './ImageWrapper.scss';

export const ImageWrapper = ({
  image, isSuccessText, showImageMessages, cartQuantity, scrollToProductPod
}) => {
  const { isMsb, isBogo, anchorItemId } = usePromoModel();
  const { isCartLoading } = usePromoCart();
  const url = sanitizeImageUrl(image.url).replace(/(400|1000)(?=(.(jpg|webp)))/, '145');

  const imageWrapperClasses = classNames('promo-image-wrapper', {
    'promo-image-wrapper--quantity': !isBogo,
  });

  return (
    <LoadingPlaceholder
      type="rect"
      ready={isMsb || !isCartLoading || (isBogo && image.itemId === anchorItemId)}
      showLoadingAnimation
      style={{
        height: '54px',
        width: '50px',
        marginRight: 0,
      }}
      color="#eeeeee"
    >
      <div
        role="button"
        tabIndex={0}
        className={imageWrapperClasses}
        onClick={scrollToProductPod}
      >
        {url ? (
          <>
            <Image
              className="promo-image"
              alt="promo product"
              src={url}
              id={image.imageId}
            />
            {cartQuantity > 0 ? <span className="promo-image--quantity">{cartQuantity}</span> : ''}
          </>
        ) : (
          <div className="promo-image--placeholder promo-image" />
        )}
        {showImageMessages && image.message && (
          <span className={`promo-image--text ${isSuccessText ? 'u__text--success promo-image--success' : ''}`}>
            {image.message}
          </span>
        )}
      </div>
    </LoadingPlaceholder>
  );
};

ImageWrapper.displayName = 'ImageWrapper';

ImageWrapper.propTypes = {
  image: shape({
    url: string,
    itemId: string,
    imageId: string,
    title: string,
    message: string,
  }),
  isSuccessText: bool,
  showImageMessages: bool,
  cartQuantity: number,
  scrollToProductPod: func
};

ImageWrapper.defaultProps = {
  image: {
    url: '',
    itemId: '',
    imageId: '',
    title: '',
    message: '',
  },
  isSuccessText: false,
  showImageMessages: false,
  cartQuantity: 0,
  scrollToProductPod: noop,
};
